// src/mixins/orderMixin.js
import { buyItAgain, getPayUrl } from '@/api/user/order.js'
import { mapMutations } from 'vuex'
import {
  clearSelected
} from '@/api/user/cart.js'

import {
  getUserInfo,
} from '@/api/user/user.js'

export const orderMixin = {
  methods: {
    ...mapMutations({
      setUserInfo: 'SET_USERINFO',
    }),
    // 个人信息
    async getUserInfoData () {
      const response = await getUserInfo()
      const res = response.data
      if (res.code === '200') {
        this.setUserInfo(res.data)
      } else {
        this.$message.error('获取个人信息失败！')
      }
    },
      // 跳转到商品详情（如果需要在多个地方使用）
    toProductDetail (id, item) {
      let data = {
        shopId: id,
        productId: item.productId,
        skuId: item.skuId
      }
      this.$router.push({
        path: '/productDetail',
        query: {
          proData: JSON.stringify(data)
        }
      })
    },
    // 再次购买公共方法
    // async buyAgain (item) {
    //   console.log(item)

    //   if (item.skus && item.skus.length === 1) {
    //     this.toProductDetail(item.shopId, item.skus[0])
    //     return
    //   }

    //    // 使用默认值处理可能不存在的字段
    //     const shopDiscountId = item.shopDiscountId || 0
    //     const shopGroupWorkId = item.shopGroupWorkId || 0
    //     const shopSeckillId = item.shopSeckillId || 0

    //     if (shopDiscountId !== 0 || shopGroupWorkId !== 0 || shopSeckillId !== 0) {
    //         this.$message.warning('商品中有活动商品，无法再次购买')
    //         return
    //     }

    //     return
    //   try {
    //     const response = await buyItAgain({ orderId: item.orderId })
    //     const res = response.data

    //     if (res.code === '200') {
    //       this.$router.push('/shopping-trolley')
    //     } else {
    //       this.$message({
    //         message: res.message,
    //         type: 'warning'
    //       })
    //     }
    //   } catch (error) {
    //     this.$message({
    //       message: '操作失败，请稍后重试',
    //       type: 'error'
    //     })
    //   }
    // },
    // 再次购买公共方法
    async buyAgain (item) {
      if (item.skus && item.skus.length === 1) {
        this.toProductDetail(item.shopId, item.skus[0])
        return
      }
      // stockNumber:无库存
      // shelveState:已下架
      // 检查是否有商品无库存
      const outOfStockItems = []
      const shelveStateItems = []
      const availableItems = []
      if (item.skus && item.skus.length > 0) {
        // 检查每个商品的库存情况
        item.skus.forEach(sku => {
          if (sku.stockNumber <= 0) {
            outOfStockItems.push(sku)
          } else if (sku.shelveState !== 1) {
            shelveStateItems.push(sku)
          } else {
            availableItems.push(sku)
          }
        })

        // 如果有无库存商品，显示确认弹窗
        if (outOfStockItems.length > 0 || shelveStateItems.length > 0) {
          let message = '<div style="text-align: left;">'
          if (outOfStockItems.length > 0) {
            message += `<p><strong>以下商品暂时无库存：</strong></p><ul style="padding-left: 20px;">`
            outOfStockItems.forEach(sku => {
              message += `<li style="font-size: 14px;border-bottom: 1px solid #E4ECF8;display: flex;padding: 5px 0;">
                  <img src="${sku.image}" alt="商品图片" style="width: 50px; height: 50px; margin-right: 10px; border-radius: 10px;">
                  ${sku.productName} ${sku.skuName || ''}
                </li>`
            })
            message += '</ul>'
          }
          if (shelveStateItems.length > 0) {
            message += `<p><strong>以下商品暂时已下架：</strong></p><ul style="padding-left: 20px;">`
            shelveStateItems.forEach(sku => {
              message += `<li style="font-size: 14px;border-bottom: 1px solid #E4ECF8;display: flex;padding: 5px 0;">
                  <img src="${sku.image}" alt="商品图片" style="width: 50px; height: 50px; margin-right: 10px; border-radius: 10px;">
                  ${sku.productName} ${sku.skuName || ''}
                </li>`
            })
            message += '</ul>'
          }

          if (availableItems.length > 0) {
            message += '<p style="margin-top: 10px;">是否继续添加剩余的商品到购物车？</p>'
          } else {
            message += '<p style="margin-top: 10px;">暂无商品可添加到购物车。</p>'
          }
          message += '</div>'

          if (availableItems.length === 0) {
            if (item.skus.length === 1) {
              this.$message.warning(`该商品无库存或已下架，无法再次购买`)
              return
            }
            this.$message.warning(`所选商品均无库存或已下架，无法再次购买`)
            return
          }

          try {
            await this.$confirm(message, '商品提醒', {
              confirmButtonText: '继续添加',
              cancelButtonText: '取消',
              dangerouslyUseHTMLString: true,
              closeOnClickModal: false
            })
          } catch (error) {
            // 用户取消操作
            return
          }

          // 如果用户确认，只添加有库存的商品
          // item.skus = availableItems
        }

        // 如果只有一个商品且有库存，直接跳转到商品详情
        // if (availableItems.length === 1) {
        //   this.toProductDetail(item.shopId, availableItems[0])
        // }
      }

      // 使用默认值处理可能不存在的字段
      const shopDiscountId = item.shopDiscountId || 0
      const shopGroupWorkId = item.shopGroupWorkId || 0
      const shopSeckillId = item.shopSeckillId || 0

      if (shopDiscountId !== 0 || shopGroupWorkId !== 0 || shopSeckillId !== 0) {
        this.$message.warning('商品中有活动商品，无法再次购买')
      }

      try {
        await clearSelected()
        const response = await buyItAgain({ orderId: item.orderId })
        const res = response.data

        if (res.code === '200') {
          this.$router.push('/shopping-trolley')
        } else {
          this.$message({
            message: res.message,
            type: 'warning'
          })
        }
      } catch (error) {
        this.$message({
          message: '操作失败，请稍后重试',
          type: 'error'
        })
      }
    },
    // 直接进购物车购买
    async buyAgainShopping (orderId) {
        if (!orderId) {
            this.$message.warning('商品信息有误，请重新选择购买')
            this.$router.push('/')
            return
        }
        const response = await buyItAgain({ orderId: orderId })
        const res = response.data
      if (res.code === '200') {
        this.$router.push('/shopping-trolley')
      } else {
        this.$message({
          message: res.message,
          type: 'warning'
        })
      }
    },
    // 申请售后
    toAfterSale (orderId) {
        // console.log(orderId)
        this.$router.push({
            path: '/afterSale',
            query: {
            state: 1,
            orderId: orderId
            }
        })
    },
        // 跳转到售后详情
    toAfterSaleDetail (afterId, orderId) {
        this.$router.push({
            path: '/afterSale',
            query: {
            state: 3,
                afterId: afterId, // 售后id
                orderId: orderId, // 订单id
            }
        })
    },
    // 获取当前时间
    getCurrentTime () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    //返回的时间如果是今天的日期就展示今天+时间，昨天的就展示昨天+时间，其他的正常展示
    formatRelativeTime (value) {
      if (!value) return ''
      const raw = String(value).trim()
      const safe = raw.replace(/-/g, '/')
      const parsed = new Date(safe)
      if (Number.isNaN(parsed.getTime())) return raw

      const hasTime = /:\d{2}/.test(raw)
      const pad2 = (n) => String(n).padStart(2, '0')
      const hhmm = `${pad2(parsed.getHours())}:${pad2(parsed.getMinutes())}`

      const now = new Date()
      const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const startOfTomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
      const startOfYesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)

      if (parsed >= startOfToday && parsed < startOfTomorrow) return hasTime ? `今天 ${hhmm}` : '今天'
      if (parsed >= startOfYesterday && parsed < startOfToday) return hasTime ? `昨天 ${hhmm}` : '昨天'
      return raw
    },
    // 跳转到评价
    toEvaluate (data) {
      this.$router.push({
        path: '/evaluate',
        query: {
          product: JSON.stringify(data)
        }
      })
    },
    // 去支付
    async getUrl (item) {
        const res = await getPayUrl({ parentId: item.parentId })
        if (res.data.code !== '200') {
            this.$message.error(res.data.message || '获取支付信息失败')
        } else {
        this.$router.push({
          path: '/orderConfirm',
          query: {
            orderId: item.orderId,
            orderFormid: item.orderFormid,
            money: item.price,
            time: item.createTime,
            isParentOrder: false,
          }
        })
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/orderMixin.js